export const THEORETICAL_EXAM_INFORMATION_ROUTE = 'informacje-o-egzaminie-teoretycznym';
